import React, {
    createContext,
    PropsWithChildren,
    useCallback,
    useContext,
    useState,
} from 'react';
import { useLoginToastContext } from './LoginToastProvider';

export const PaymentOutageContext = createContext<{
    open: boolean;
    handleOpen: (showLoginToast?: boolean) => unknown;
    handleClose: () => unknown;
}>({
    open: false,
    handleOpen: () => null,
    handleClose: () => null,
});

export const usePaymentOutageContext = () => useContext(PaymentOutageContext);

const PaymentOutageProvider: React.FC<PropsWithChildren> = ({ children }) => {
    const [open, setOpen] = useState<boolean>(false);
    const [showLoginToast, setShowLoginToast] = useState<boolean>(false);
    const { handleOpenLoginToast } = useLoginToastContext();

    const handleOpen = useCallback(
        (showLoginToast: boolean = false) => {
            setOpen(true);
            setShowLoginToast(showLoginToast);
        },
        [setOpen, setShowLoginToast],
    );

    const handleClose = useCallback(() => {
        setOpen(false);
        if (showLoginToast) {
            setShowLoginToast(false);
            handleOpenLoginToast();
        }
    }, [showLoginToast, setOpen, handleOpenLoginToast]);

    return (
        <PaymentOutageContext.Provider
            value={{
                open,
                handleOpen,
                handleClose,
            }}
        >
            {children}
        </PaymentOutageContext.Provider>
    );
};

export default PaymentOutageProvider;
